/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { Component, OnInit, Renderer2, ViewChild } from '@angular/core';
import { DynamicComponentContainerDirective } from "./dynamic-component-container.directive";
import { DriverDataTable } from './driver-data-table/driver-data-table';

@Component({
    selector: 'driverSearch',
    template: `
    <div class="input-group">
      <span class="input-group-addon">{{'Label-Search' | translate}}</span>

      <input id="searchForDrivers" #searchForDrivers type="text" class="form-control" style="width: 200px; margin-right: 10px;" (keydown.enter)="createComponent('DriverDataTable', {
        inputs  : { searchFor: searchForDrivers.value},
        outputs : {}
      })" />

      <button id="SubmitSearch" type="button" class="btn btn-secondary" style="padding: 5px 10px;" (click)="createComponent('DriverDataTable', {
        inputs  : { searchFor: searchForDrivers.value},
        outputs : {}
      })">

        <i class="fa fa-search"></i> {{'Button-Submit' | translate}}
      </button>
      <button id="ResetSearch" type="button" class="btn btn-secondary" style="padding: 5px 10px;" (click)="createComponent('DriverDataTable', {
        inputs  : { searchFor: ''},
        outputs : { }
      }); searchForDrivers.value=''; searchForDrivers.focus();">
        <i class="fa fa-refresh"></i> {{'Button-Reset' | translate}}
      </button>
    </div>

    <ng-container dynamicComponentContainer></ng-container>
  `,
    standalone: false
})
export class DriverSearchComponent implements OnInit {
    @ViewChild(DynamicComponentContainerDirective)
    entryContainer: DynamicComponentContainerDirective;

    constructor(
        private render: Renderer2) { }

    ngOnInit() {
        this.render.selectRootElement('#searchForDrivers').focus();
    }

    createComponent(name: string, metadata: any) {
        const viewContainerRef = this.entryContainer.viewContainerRef;
        viewContainerRef.clear();
        const cmpRef = viewContainerRef.createComponent(DriverDataTable);

        for (let input in metadata.inputs) {
            if (metadata.inputs.hasOwnProperty(input)) {
                cmpRef.instance[input] = metadata.inputs[input];
            }
        }

        for (let output in metadata.outputs) {
            if (metadata.outputs.hasOwnProperty(output)) {
                cmpRef.instance[output].subscribe(metadata.outputs[output]);
            }
        }
    }

    handleOutput(event) {
        console.log('handle output', event);
    }

    handleOutputAlternative(event) {
        console.log('handle output alternative', event);
    }

}
